import type { common as en } from '../en/common';

export const common: Record<keyof typeof en, string> = {
  'common.save': 'सहेजें',
  'common.cancel': 'रद्द करें',
  'common.close': 'बंद करें',
  'common.done': 'हो गया',
  'common.back': 'वापस',
  'common.delete': 'मिटाएँ',
  'common.remove': 'हटाएँ',
  'common.retry': 'फिर कोशिश करें',
  'common.updateRequired.title':
    'नए संदेश भेजते और पढ़ते रहने के लिए Twinden अपडेट करें',
  'common.updateRequired.action': 'अपडेट करें',
  'common.updateRequired.needsUpdate': 'Twinden का अपडेट चाहिए',
  'common.somethingWrong': 'कुछ गड़बड़ हो गई',
  // Waiting on the server (M66, D247–D249)
  'common.loading': 'लोड हो रहा है…',
  'common.loading.chats': 'चैट लोड हो रही हैं…',
  'common.loading.messages': 'संदेश लोड हो रहे हैं…',
  'common.loading.slow':
    'अभी भी लोड हो रहा है… Twinden के सर्वर को थोड़ा समय लग रहा है।',
  'common.loading.failed': 'यह लोड नहीं हुआ।',
  'common.loading.offline': 'आप ऑफ़लाइन हैं। वापस आने पर हम इसे लोड कर देंगे।',
  'common.loading.tryAgain': 'फिर कोशिश करें',
  // A device still without its key, in an encrypted family or chat (M28)
  'e2ee.keysNotReady':
    'यह डिवाइस अभी अपनी चाबियाँ ले रहा है। कुछ नहीं भेजा गया — थोड़ी देर में फिर कोशिश करें।',
  // A sealed picture over the server's limit (M72)
  'e2ee.pictureTooLarge':
    'यह फ़ोटो भेजने के लिए बहुत बड़ी है। कोई छोटी फ़ोटो चुनें।',
  // No family's key has reached this device to hold a picture's key (D292)
  'e2ee.pictureNoFamilyKey':
    'आपकी फ़ोटो नहीं लगी: इस डिवाइस के पास अभी आपके परिवार की चाबियाँ नहीं हैं। थोड़ी देर में फिर कोशिश करें।',
  // In no family yet: no one could see a picture (D292)
  'e2ee.pictureNoFamily':
    'किसी परिवार में शामिल होने के बाद आप अपनी फ़ोटो लगा सकते हैं।',
  // My sealed picture can't be opened anywhere any more (D295)
  'e2ee.pictureLost':
    'आपकी फ़ोटो अब खुल नहीं सकती, इसलिए आपके परिवार को आपके नाम के अक्षर दिखते हैं। अपनी प्रोफ़ाइल में इसे फिर से लगाएँ।',
  'common.you': 'आप',
  'settings.language.title': 'भाषा और क्षेत्र',
  'settings.language.description':
    'ऐप के शब्द, और इस डिवाइस पर तारीख़, समय और संख्याएँ कैसी दिखें।',
  'settings.language.label': 'भाषा',
  'settings.language.device': 'इस डिवाइस जैसी',
  'settings.language.hint':
    'संदेश वैसे ही रहते हैं जैसे लोगों ने लिखे; सिर्फ़ Twinden के अपने शब्द बदलते हैं।',
};
